import { useRoutingProviderState } from "../contexts/RoutingProvider";
import "./dapp.css";
import "./animatedIcons.css";
import { ReactComponent as HamburgerSVG } from "../assets/hamburger.svg";
import { ReactComponent as TIKTOK } from "../assets/tiktok.svg";
import { ethers } from "ethers";
import Swal from "sweetalert2";
import {
  useWeb3ProviderDispatch,
  useWeb3ProviderState,
} from "../contexts/Web3Provider";
import { useUIProviderDispatch } from "../contexts/UIProvider";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import Chart from "./pages/Chart";
import Social from "./pages/Social";
import {
  PROMOTIONAL_TOKEN_NAME,
  PROMO_TOKEN_TELEGRAM,
} from "../assets/constants";

export default function Viewport() {
  const routingState = useRoutingProviderState();
  const web3State = useWeb3ProviderState();
  const uiDispatch = useUIProviderDispatch();

  return (
    <div className={`viewportContainer gradientBorder`}>
      <div className={`viewport gradientBackground`}>
        {routingState.navLocation === "DAPP" && <Dapp />}
        {routingState.navLocation === "HOME" && <Home />}
        {routingState.navLocation === "CHART" && <Chart />}
        {routingState.navLocation === "FAQ" && <FAQ />}
        {routingState.navLocation === "WHITEPAPER" && <WhitePaper />}
        {routingState.navLocation === "SOCIAL" && <Social />}
      </div>
      <div
        className="hamburgerMenu"
        onClick={(e) => {
          e.stopPropagation();
          uiDispatch({ type: "TOGGLE_MENU_VISIBLE" });
        }}
      >
        <HamburgerSVG />
      </div>
    </div>
  );
}

// async function init

function Dapp() {
  const web3State = useWeb3ProviderState();
  const web3Dispatch = useWeb3ProviderDispatch();

  async function getUserData() {
    console.log("user balance");
    if (web3State.currentContract && web3State.currentWallet) {
      const balance = await web3State.currentContract.balanceOf(
        web3State.currentWallet
      );
      const rewards = await web3State.currentContract.rewardsOf(
        web3State.currentWallet
      );
      const nextSell = await web3State.currentContract.nextSellOf(
        web3State.currentWallet
      );

      web3Dispatch({ type: "UPDATE_USER_TOKEN_BALANCE", payload: balance });
      web3Dispatch({ type: "UPDATE_USER_TOTAL_REWARDS", payload: rewards });
      // web3Dispatch()
      // web3Dispatch()
      // console.log(balance.toString())
    }
  }
  useEffect(() => {
    getUserData();
  }, [web3State.currentWallet]);
  console.log(web3State);

  if (web3State.currentWallet) {
    return (
      <div className="dapp-container">
        <div className="dapp-top">
          <div className="dapp-summary">
            <span>SUMMARY</span>
            <div className="dapp-summary-icon-container">
              <div className="dapp-summary-icon-ee"></div>
              <div className="dapp-summary-data">
                <span
                  style={{
                    color: "var(--text-header-blue)",
                    fontFamily: "var(--header1)",
                  }}
                >
                  TOKEN BALANCE
                </span>
                <span style={{ color: "white" }}>
                  {web3State.userTokenBalance}
                </span>
              </div>
            </div>
            <div className="dapp-summary-icon-container">
              <div className="dapp-summary-icon-bnb"></div>
              <div className="dapp-summary-data">
                <span
                  style={{
                    color: "var(--text-header-red)",
                    fontFamily: "var(--header1)",
                  }}
                >
                  TOTAL REWARDS
                </span>
                <span style={{ color: "white" }}>
                  {web3State.userTotalRewards} BNB
                </span>
              </div>
            </div>
          </div>
          <div className="dapp-claim">
            <span>CLAIM REWARDS</span>
            <div
              className="dapp-claim-button-cmp"
              onClick={async () => {
                try {
                  if (web3State.currentWallet) {
                    const p = new ethers.providers.Web3Provider(
                      web3State.walletProvider
                    );
                    const signer = p.getSigner();
                    console.log(signer);
                    const contractSigner =
                      await web3State.currentContract.connect(signer);
                    console.log(contractSigner);
                    const res = await contractSigner.compound();
                    console.log(res);
                    getUserData()
                  }
                } catch (e) {
                  console.log(e);
                }

                // debugger
                // console.log(res)
              }}
            >
              COMPOUND REWARDS
            </div>
            <div
              className="dapp-claim-button-claim"
              onClick={async () => {
                try {
                  if (web3State.currentWallet) {
                    const p = new ethers.providers.Web3Provider(
                      web3State.walletProvider
                    );
                    const signer = p.getSigner();
                    console.log(signer);
                    const contractSigner =
                      await web3State.currentContract.connect(signer);
                    console.log(contractSigner);
                    const res = await contractSigner.claimBNB();
                    console.log(res);
                    getUserData()
                  }
                } catch (e) {
                  console.log(e);
                }

                // debugger
                // console.log(res)
              }}
            >
              CLAIM BNB
            </div>
            <div
              className="dapp-claim-button-claim-any"
              onClick={async () => {
                const { value: token } = await Swal.fire({
                  title: "Input token address",
                  input: "text",
                  inputLabel: "Address needs to be a valid BEP-20 token.",
                  inputPlaceholder: "Enter token address",
                  showCancelButton: true,
                  inputValidator: (val) => {
                    const rex = new RegExp(/^0x[a-fA-F0-9]{40}$/);
                    if (!rex.test(val)) {
                      return "Not A BSC Address";
                    }
                    return null;
                  },
                });
                console.log(token);
                if (token) {
                  try {
                    if (web3State.currentWallet) {
                      const p = new ethers.providers.Web3Provider(
                        web3State.walletProvider
                      );
                      const signer = p.getSigner();
                      console.log(signer);
                      const contractSigner =
                        await web3State.currentContract.connect(signer);
                      console.log(contractSigner);
                      const res = await contractSigner.claimAnyToken(token);
                      console.log(res);
                      getUserData()
                    }
                  } catch (e) {
                    console.log(e);
                  }
                }
              }}
            >
              CLAIM ANY BSC TOKEN
            </div>
          </div>
        </div>

        <div className="dapp-bottom">
          <div className="promo-token-border gradientBorder">
            <div className="promo-token-modal">
              <div className="promo-logo-container">
                <div className="promo-logo">
                  <div className="inner-promo-logo"></div>
                </div>
                <div className="promo-claim-button-container">
                  <div
                    className="dapp-claim-button-promo"
                    onClick={async () => {
                      try {
                        if (web3State.currentWallet) {
                          const p = new ethers.providers.Web3Provider(
                            web3State.walletProvider
                          );
                          const signer = p.getSigner();
                          console.log(signer);
                          const contractSigner =
                            await web3State.currentContract.connect(signer);
                          console.log(contractSigner);
                          const res = await contractSigner.claimPromoToken(); // claim promo fomo
                          console.log(res);
                          getUserData()
                        }
                      } catch (e) {
                        console.log(e);
                      }

                      // debugger
                      // console.log(res)
                    }}
                  >
                    <span style={{ color: "var(--promo-claim-text)" }}>
                      CLAIM PARTNER TOKEN
                    </span>
                  </div>
                </div>
              </div>
              <div className="promo-right-side">
                <span>PARTNER TOKEN</span>
                <span>{PROMOTIONAL_TOKEN_NAME}</span>
                <span>MORE DETAILS</span>
                <a href={PROMO_TOKEN_TELEGRAM} target="_blank">
                  <i className="fa fa-telegram fa-2x"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="connect-wallet">
        <h1>Please sign in by connecting your Wallet</h1>
      </div>
    );
  }
}

function Home() {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 500px)" });

  return (
    <div className="home-tab">
      <div className="home-top">
        <p style={isTabletOrMobile ? { margin: "3rem 0 0 0" } : {}}>
          THE <span style={{ color: "var(--text-header-blue)" }}>EAGLE</span>
          <span style={{ color: "var(--text-header-red)" }}>EYE</span> TOKEN
        </p>
        <span>
          Unlike similar products, EagleEye does not require users to hold our
          native token to gain access to the EagleEye suite. Rather, the token
          represents a commitment to the betterment of security and safety
          through EagleEye development. Users that hold EagleEye gain rewards
          over time through custom tokenomics, while enjoying top-tier security,
          partnerships, and promotions with some of the DeFi space's hottest
          projects.
        </span>
      </div>
      <div className="home-bottom">
        <p>
          CUSTOM <span style={{ color: "var(--text-header-blue)" }}>TOKEN</span>
          OMICS
        </p>
        <span>
          The EagleEye contract is not a clone, but rather custom made to
          properly serve our project. Through the implementation of a rolling
          liquidity lock, EagleEye ensures investor confidence while maintain
          the ability to migrate our liquidity pool between exchange versions -
          preventing a situation where liquidity is locked permanently on an
          outdated system. Contract Address :
          0x4e6a510659d3d0F6897bbab3Db67DA0B3d001fB7
        </span>
      </div>
    </div>
  );
}

function WhitePaper() {
  return (
    <div className="whitepap-page">
      <a href="/EagleEye_Whitepaper.pdf">WHITEPAPER.PDF</a>
    </div>
  );
}
function FAQ() {
  return <div></div>;
}
